import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'y42-context-menu-bring-to',
  templateUrl: './context-menu-bring-to.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuBringToComponent {
  @Output()
  bringToFront = new EventEmitter();

  @Output()
  sendToBack = new EventEmitter();
}
